import { useState, useCallback } from 'react';

export function useToast() {
    const [toasts, setToasts] = useState([]);

    const dismiss = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);

    const toast = useCallback(({ title, description, variant, duration = 5000 }) => {
        const id = Math.random().toString(36).substring(7);
        const newToast = { id, title, description, variant };

        setToasts((prev) => [...prev, newToast]);

        setTimeout(() => {
            dismiss(id);
        }, duration);
    }, [dismiss]);

    return { toasts, toast, dismiss };
}
